module.exports = __webpack_public_path__ + "img/logo-santanu.b4e19770.png";